import React from 'react';

import GuideFilter from './filter';
import FilterSettings from './constants';
import LoginModal from './login-modal';
import ToggleButton from './ui-components/toggle-button';

import PageGroups from './guide-components/page-groups';

import DestinationFilters from "./guide-components/destination-filters"
import DestinationSettings from "./guide-components/destination-settings"
import DestinationFilterController from "./guide-components/destination-filter-controller"

var FavoritesAPI = require('../utils/favorites-api');
var FavoritesActions = require('../actions/favorites-actions');
import UserStore from '../stores/user-store';

var MobileDestinationHeader = React.createClass(_.merge(DestinationFilterController, {
  getInitialState: function(){
    return _.merge( DestinationSettings, { currentView: "hidden" } );
  },

  toggleFilters: function(){
    this.setState({ currentView: this.state.currentView === "filters" ? "hidden" : "filters" });
  },

  toggleMenu: function(){
    this.setState({ currentView: this.state.currentView === "menu" ? "hidden" : "menu" });
  },

  changeOption: function(id, type){
    this.handleOptionChange(id, type);
    this.closeAll();
  },

  render: function() {
    var self = this;

    var filterSettings = DestinationSettings.filter,
        viewSettings = DestinationSettings.view,
        sortSettings = DestinationSettings.sort;

    var filterMarkup = _.map(filterSettings.values, function(v, k){
      var active = filterSettings.selected.indexOf(k) !== -1;

      return ( <ToggleButton status={ active } id={ k } label={ v } onToggle={ self.toggleFilterSelections }></ToggleButton> )
    })

    //TODO: this could be a method if you feel like refactoring
    var viewMarkup = _.map(viewSettings.values, function(v, k){
      var colorClass = viewSettings.selected === k ? "btn-light" : "btn-dark";

      return (
        <div className={ "btn grid-btn " + colorClass } onClick={ self.changeOption.bind(self, k, "view") }>
          <i className={ "fa" + viewSettings.icons[k] }></i>
          <span>{ v.replace(/view/i, "") }</span>
        </div>
      )
    })

    var sortMarkup = _.map(sortSettings.values, function(v, k){
      var colorClass = sortSettings.selected === k ? "btn-light" : "btn-dark";

      return (
        <div className={ "btn grid-btn " + colorClass } onClick={ self.changeOption.bind(self, k, "sort") }>
          <i className={ "fa" + sortSettings.icons[k] }></i>
          <span>{ v }</span>
        </div>
      )
    })

    var completeButtons = (
      <div className='complete-btns'>
        <div className='btn complete-btn apply' onClick={ function(){ self.applyChanges(); self.closeAll() } }>Apply</div>
        <div className='btn complete-btn cancel' onClick={ this.cancel }>Cancel</div>
      </div>
    );

    return (
      <div className='mobile-header-btns'>
        <div>
          <div className="btn btn-md" onClick={this.toggleFilters}>
            <i className='fa fa-filter'></i>
          </div>
          <div className="btn btn-md" onClick={this.toggleMenu}>
            <i className='fa fa-ellipsis-h'></i>
          </div>
        </div>

        <div className= { 'mobile-menu filter-menu ' + (this.state.currentView === "filters" ? "active" : "") }>
          <div className="mobile-filters">
            <div className='content'>
              <div className="menu-pointer"></div>
          
              <label>Filter</label>
              <div className='standard-filters' onclick>
                { filterMarkup }
              </div>

              {
              /*
              // TODO: Add in favorites 
              // <div className='special-filters'>
              //   <ToggleButton label='Favorites' id='favorite' status={ false } onToggle={ this.toggleFavorites }></ToggleButton>
              // </div>
              */
              }
      
              { completeButtons }
            </div>
          </div>
        </div>

        <div className= { 'mobile-menu options-menu ' + (this.state.currentView === "menu" ? "active" : "") }>
          <div className="content">
            <div className="menu-pointer"></div>
            <div className="mobile-filters">
              <div className="mobile-view-filters">
                <label>View</label>
                { viewMarkup }
              </div>

              <div className="mobile-sort-filters">
                <label>Sort</label>
                { sortMarkup }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}));

var DestinationHeader = React.createClass({
  render: function(){
    var self = this,
        guideState = this.props.guideState,
        guideApi = this.props.guideApi;

    var loading = null,
        destName = _.startCase(guideState.destination).replace('Washington Dc', 'Washington DC').replace('New York', 'New York City');

    if (guideState.isSmallScreen){
      var mobileHeader = <MobileDestinationHeader onFilterChange={ guideApi.updateFilters } getCurrentFilters={ guideApi.getFilters } />;
    } else {
      var mobileHeader = <DestinationFilters onFilterChange={ guideApi.updateFilters } getCurrentFilters={ guideApi.getFilters } />
    }
    
    return (
      <div className="header destination-header row">
        <div className="header-title col-xs-12 col-sm-7">
          <div className="trip-title" style={{ float: 'left' }}>
            <h1>Things to do in {destName} {loading}</h1>
          </div> 
        </div>
        { mobileHeader }
      </div>
    );
  }
});

var DestinationGuide = React.createClass({

  defaults: {
    viewType: "grid-view",
    sortType: "rank",
    filters: []
  },
  
  updateQueryStringParam: function(key, value) {
    var baseUrl = [location.protocol, '//', location.host, location.pathname].join('');
    var urlQueryString = document.location.search;
    var newParam = key + '=' + value,
        params = '?' + newParam;
    
    // If the "search" string exists, then build params from it
    if (urlQueryString) {
      var keyRegex = new RegExp('([\?&])' + key + '[^&]*');
      // If param exists already, update it
      if (urlQueryString.match(keyRegex) !== null) {
        params = urlQueryString.replace(keyRegex, "$1" + newParam);
      } else { // Otherwise, add it to end of query string
        params = urlQueryString + '&' + newParam;
      }
    }
    window.history.replaceState({}, "", baseUrl + params);
  },
  
  updateURL: function(params) {
    this.updateQueryStringParam('sort', params.sort);
    this.updateQueryStringParam('view', params.view);
    this.updateQueryStringParam('filter', params.filter.map(function(f) { return f.toLowerCase(); }));
  },

  trackEvent: function(type) {
    switch (type) {
      case "view":
        ga('send', "event", "change-view", this.state.viewType);
        break;
      case "sort":
        ga('send', "event", "sort", this.state.sortType)
        break;
      case "filter":
        if (this.state.filters.length > 0){
          ga('send', "event", "filter", "apply-filter", this.state.filters.join(", ") );
        } else {
          ga('send', "event", "filter", "clear-filter", "None");
        }
        break;
      default:
        ga('send', 'pageview', { page: location.pathname + location.search, nonInteraction: true });
    }
  },
  
  getParameterByName: function(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  },
  
  getInitialParams: function() {
    var params = {};
    
    params.viewType = this.getParameterByName('view') || this.defaults.viewType;
    params.sortType = this.getParameterByName('sort') || this.defaults.sortType;
    params.filters = this.getParameterByName('filter') || this.defaults.filters;
    if (typeof params.filters === 'string') {
      params.filters = params.filters.split(/,/).map(function(f) { return f.toLowerCase(); });
    }
    params.destination = window.location.pathname.replace(/\/([^/]+)\/(guide|trip).*/, "$1");

    return params;
  },
  
  getInitialState: function() {
    var params = this.getInitialParams();
    var initState = {
      loading: false,
      isSmallScreen: false,
      mobileCurrentView: 'grid-view',
      viewType: "grid-view",
      sortType: "rank",
      filters: []
    };

    return _.merge(initState, params);
  },

  componentDidMount: function() {
    this.fetchGuide();
    this.updateScreenType();
    window.addEventListener('resize', this.handleResize);

    setTimeout(() => FavoritesAPI.getAllFavorites(), 200);
    UserStore.addChangeListener(this.onChangeLogin);
  },

  componentWillUnmount: function() {
    window.removeEventListener('resize', this.handleResize);

    UserStore.removeChangeListener(this.onChangeLogin);
  },

  handleResize: function(e) {
    this.updateScreenType();
  },

  updateScreenType: function(){
    var width = $(window).width();

    this.setState({
      isSmallScreen: (width < 768)
    });
  },

  onChangeView: function(view) {
    this.setState({
      mobileCurrentView: view
    });
  },

  onChangeLogin: function() {
    if (UserStore.isLoginRequired) {
      this.setState({loginRequired: true}, () =>
                    this.setState({loginRequired: false}));
    }
  },

  getWeekday: function(date) {
    return moment(date).format("dddd").toLowerCase();
  },
  
  onFilterChange: function(state) {
    this.setState({ viewType: state.view.selected });
  },

  getSearchQueryString: function(){
    var sort = this.state.sortType;

    return "?destination=" + this.state.destination.replace(/\//g, "") + "&sort_by=" + sort + "&tags=" + this.state.filters.join(",") + "&requiredTags=Attraction";
  },

  fetchGuide: function() {
    var that = this,
        filters = this.state.filters,
        listIcons = {
          "new-york-top-activities": "icon-icons_activities_alt",
          "new-york-top-restaurants": "icon-icons_dining"
        }

    var filterQuery = this.getSearchQueryString(); (filters && filters.length > 0) ? ( '&filter=' + filters.join(',') ) : '';
    that.setState({ loading: true });

    var apiHref = (filters.length === 0 && this.state.sortType === this.defaults.sortType) ? '/api/landing' + this.state.destination : "/api/search" + filterQuery;

    $.get(apiHref).done(function(data){
        data.groups = [];

        if (!!data.Attractions){ 
          data.Attractions.unshift({
            bucket: 'guides',
            destination: "new-york",
            id: "new-york",
            name: "Essential Guide To New York",
            itemClass: "travel-guide"
          });
          
          data.groups.push({
            name: "Attractions", 
            items: data.Attractions, 
            icon: "icon-icons_attractions"
          });
        } else {
          data.groups.push({
            name: "Attractions", 
            items: data, 
            icon: "icon-icons_attractions"
          })
        }

        if (!!data.Ideas && data.Ideas.length > 0) data.groups.push({name: "Expert Trip Ideas", items: data.Ideas, icon: "icon-icons_tripidea"})
        if (!!data.Lists){
          for (var x in data.Lists){
            if (typeof data.Lists[x] === 'object')
              data.groups.push({name: data.Lists[x].name, items: data.Lists[x].Places, icon: listIcons[data.Lists[x].id]});
          }
        }

        that.setState({plan: data, loading: false});
        $(window).trigger( "filters-changed" );
    });
  },
  
  render: function() {
    if (this.state.viewType === "grid-view" && this.state.sortType === "rank" && this.state.filters.length === 0){
      $("#destination-guide-container").addClass("static-view");
    } else {
      $("#destination-guide-container").removeClass("static-view");
    }

    var self = this;

    var guideApi = {
      updateState: function(obj){ 
        self.setState(obj) 
      },
      updateFilters: function(obj){ 
        var viewChanged = obj.view.selected !== self.state.viewType,
            sortChanged = obj.sort.selected !== self.state.sortType,
            filterChanged = _.xor(obj.filter.selected, self.state.filters).length > 0;
        
        var gaEvent = viewChanged ? "view" : sortChanged ? "sort" : "filter"; 

        if (sortChanged || filterChanged){ 
          self.setState({
            viewType: obj.view.selected,
            sortType: obj.sort.selected,
            filters: obj.filter.selected,
            loading: true
          }, function(){
            self.fetchGuide();
            self.updateURL({ sort: obj.sort.selected, view: obj.view.selected, filter: obj.filter.selected });
            self.trackEvent(gaEvent);
          });
        } else {
          self.setState({
            loading: true
          }, function(){
            setTimeout(function(){
              self.setState({
                loading: false,
                viewType: obj.view.selected
              }, function(){
                self.updateURL({ sort: obj.sort.selected, view: obj.view.selected, filter: obj.filter.selected });
                self.trackEvent(gaEvent);
                $(window).trigger( "view-changed" );
              })
            }, 200);
          })
        }
      },
      getFilters: function(){
        return {
          view: self.state.viewType,
          sort: self.state.sortType,
          filter: self.state.filters
        }
      }
    }

    return (
      <div>
        <DestinationHeader guideState={ this.state } guideApi={ guideApi } />

        <section className="container" style={{ opacity: (this.state.loading ? 0 : 1) }}>
          <div className='main-group'>
            <PageGroups plan={this.state.plan} groups={( !!this.state.plan ? [this.state.plan.groups[0]] : [] )} guideState={this.state} guideApi={guideApi} startingDate={this.state.startingDate} numPlaces={this.state.numPlaces}
                      isSmallScreen={this.state.isSmallScreen} filter={this.state.filters}
                      mobileCurrentView={this.state.mobileCurrentView} loading={this.state.loading}
                      onChangeView={this.onChangeView} numDays={this.state.numDays} destination={this.state.destination} pace={this.state.pace}
                      onFilterChange={this.onFilterChange} viewType={ this.state.viewType } mapFor=".day:first" autoImageUrls={ true } />
          { this.state.viewType === "list-view" ? <div className='footnote'>* Recommended Hours</div> : null }
          </div>
          <div className='secondary-group'>
            <PageGroups plan={this.state.plan} groups={( !!this.state.plan ? this.state.plan.groups.slice(1) : [] )} guideState={this.state} guideApi={guideApi} startingDate={this.state.startingDate} numPlaces={this.state.numPlaces}
                      isSmallScreen={this.state.isSmallScreen} filter={this.state.filters}
                      mobileCurrentView={this.state.mobileCurrentView} loading={this.state.loading}
                      onChangeView={this.onChangeView} numDays={this.state.numDays} destination={this.state.destination} pace={this.state.pace}
                      onFilterChange={this.onFilterChange} viewType="grid-view" mapFor={ null } autoImageUrls={ true } />
          </div>
        </section>
        <LoginModal loginRequired={this.state.loginRequired}/>
      </div>
    );
  }
});

module.exports = DestinationGuide;



// WEBPACK FOOTER //
// ./components/destination-guide.js